import { isMultiUserCanisterUser, userCanisterId, userIndexWithinCanister } from "./userId";
// The url of a blob belonging to `ownerId`: the canister which serves it, such as a group, community
// or storage bucket, or a user, whose blobs are served by the canister holding them (see
// `blobLocation`)
export function buildBlobUrl(pattern, ownerId, blobId, blobType, { channelId, botId } = {}) {
    const location = channelId === undefined
        ? blobLocation(ownerId, blobType)
        : { canisterId: ownerId, path: `channel/${channelId}/${blobType}` };
    const botSegment = botId === undefined ? "" : `/${botId}`;
    return `${fillPattern(pattern, location.canisterId, location.path)}${botSegment}/${blobId}`;
}
// The url of the logo of the token on `ledger`, which the Registry canister serves
export function buildTokenLogoUrl(pattern, registryCanisterId, ledger, logoId) {
    return `${fillPattern(pattern, registryCanisterId, "logo")}?ledger=${ledger}&id=${logoId}`;
}
// Where the blobs of `ownerId`, such as its avatar, are served: the canister to fetch them from and
// the path under which that canister serves blobs of `blobType`. A group or community serves its own
// at its root. A MultiUser canister serves those of each of its users under `user/{index}`, where
// `index` is the user's index within it (see `Route::User` in backend/libraries/http_request).
export function blobLocation(ownerId, blobType) {
    if (!isMultiUserCanisterUser(ownerId)) {
        return { canisterId: ownerId, path: blobType };
    }
    return {
        canisterId: userCanisterId(ownerId).toText(),
        path: `user/${userIndexWithinCanister(ownerId)}/${blobType}`,
    };
}
function fillPattern(pattern, canisterId, path) {
    return pattern.replace("{canisterId}", canisterId).replace("{blobType}", path);
}
